import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { AppConfig } from 'sigv-library';
import { Configuration as RbacApiConfig } from 'src/app/api-info/system-management-api/configuration';

@Injectable({
  providedIn: 'root',
})
export class UserIdentifyService {
  constructor( private logger: NGXLogger, private appConfig: AppConfig) {}

  /**
   * 判斷是否為外網且登入者是 Sales
   */
  getRbacConfig(): RbacApiConfig{
    const appConfig: any = this.appConfig;
    const isExtra = appConfig?.isWebSubmissionExtranetSalesLogin();
    
    let rbacApiInfoUrl='';
    if(isExtra === true){
      rbacApiInfoUrl = appConfig?.env?.apiSalesUrl.rbac.replace('/Rbac','');
    }else{
      rbacApiInfoUrl = appConfig?.env?.apiUrl.rbac.replace('/Rbac','');
    }
    const rbacConfig = new RbacApiConfig({
      basePath: rbacApiInfoUrl,
    });
    return rbacConfig;
  }
}
